/* eslint-disable max-lines */
import { useCallback, useEffect, useMemo, useState } from 'react'
import omit from 'lodash/omit'

import { message as $message } from 'antd'
import Qs from 'qs'
import {
    CHANNEL_ORDER_ROUTE,
    SUPPLIER_ORDER_ROUTE,
    CHANNEL_PROCE_QUANTITY,
    SUPPLIER_PROCE_QUANTITY,
    CHANNEL_HOME_PAGE,
    SUPPLIER_ONLINE_SUPPLIERS,
    SUPPLIER_SHOP_LIST,
    SUPPLIER_AFTER_SALES_AUTOMATION,
    CHANNEL_AFTER_SALES_AUTOMATION,
    CHANNEL_SHOP_LIST,
    CHANNEL_PRATER_SHIP,
    SUPPLY_PRATER_SHIP,
} from '@/modules/order/constants'

import { acquireSimpleUser } from '@/services/user'
import { erpJointLoginGyl2, afterLogin, syncApplyCooperationNum } from '@/services/login'
import { getHome } from '@/utils/role'
import { jstLogPv } from '@/utils/logger'
import { getTerminaDomain, parseUrl } from '@/utils/utils'
import { isLightChannel, isZongHengApp } from '@/utils/singleApp'
import { getToken, setToken } from '@/utils/token'
import * as Sentry from '@sentry/react'
import * as erpKeys from '@/modules/globals/constants/erpJumpPageKeys'
import { setParams } from '@/utils/url'
import { captureException } from '@/utils/track'
import { getLocalTerminalDomain } from '@/utils/terminal'

const TERMINAL_APP = 'APP'
const TERMINAL_PC = 'PC'

export { getLocalTerminalDomain }

export const SUPPLIER_HOME = `${getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)}/manage/goods/goodsManage/index`
export const CHANNEL_HOME = `${getTerminaDomain(PROJECT_CONFIG.channelTerminalName)}/channel/businessDynamics`

export const LOGIN_URL = `${getTerminaDomain(PROJECT_CONFIG.accountTerminalName)}/user/login`
export const ROLE_URL = `${getTerminaDomain(PROJECT_CONFIG.accountTerminalName)}/role/choose`

const stringify = query => Qs.stringify(query, { addQueryPrefix: true })

// 解决erp菜单栏链接不能过长问题
const R_MAP = {
    // 供销订单（新增）
    [erpKeys.ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_ORDER]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/tradeManage/tower/distribute${stringify({
        ffrom: erpKeys.ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_ORDER,
        orderStatus: 'WaitPay,WaitConfirm,WaitOuterSent,Question',
        orderTypeEnum: 'INCLUDE_SUP',
    })}`,

    // 供应商工具的分销售后
    [erpKeys.ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_AFTER_SALES]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/afterSaleManage/distributorAfterSales${stringify({
        ffrom: erpKeys.ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_AFTER_SALES,
    })}`,

    // 分销商数据（新增）
    [erpKeys.ERP_MENU_SUPPILER_TOOL_DISTRIBUTION_DATA]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/partnerManage/distributionAccountCenter${stringify({
        ffrom: erpKeys.ERP_MENU_SUPPILER_TOOL_DISTRIBUTION_DATA,
    })}`,
    [erpKeys.ERP_NAVIGATION]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/manage/goods/goodsManage/index${stringify({
        ffrom: erpKeys.ERP_NAVIGATION,
    })}`,
    [erpKeys.ERP_NAV_ORDER]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}${SUPPLIER_ORDER_ROUTE}${stringify({
        ffrom: erpKeys.ERP_NAV_ORDER,
        orderStatus: 'WaitConfirm,WaitOuterSent,Question',
        orderTypeEnum: 'DIS',
    })}`,
    // 分销售后（新增）
    [erpKeys.ERP_MENU_DISTRIBUTOR_TOOL_DISTRIBUTION_AFTER_SALES]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/afterSaleManage/afterSales${stringify({
        ffrom: erpKeys.ERP_MENU_DISTRIBUTOR_TOOL_DISTRIBUTION_AFTER_SALES,
    })}`,
    // 供应商数据（新增）
    [erpKeys.ERP_MENU_DISTRIBUTOR_TOOL_DISTRIBUTION_SUPPLIER_DATA]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/suppliersManage/supplierAnalysis${stringify({
        ffrom: erpKeys.ERP_MENU_DISTRIBUTOR_TOOL_DISTRIBUTION_SUPPLIER_DATA,
    })}`,
    [erpKeys.ERP_NAV_ORDER2]: {
        [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
            PROJECT_CONFIG.supplierTerminalName,
        )}${SUPPLIER_ORDER_ROUTE}${stringify({
            ffrom: erpKeys.ERP_NAV_ORDER2,
            orderStatus: 'WaitConfirm,WaitOuterSent,Question',
            orderTypeEnum: 'DIS',
        })}`,
        [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
            PROJECT_CONFIG.channelTerminalName,
        )}${CHANNEL_ORDER_ROUTE}${stringify({
            ffrom: erpKeys.ERP_NAV_ORDER2,
            orderStatus: 'WaitConfirm,WaitOuterSent,Question',
            orderTypeEnum: 'DIS',
        })}`,
    },
    [erpKeys.ERP_NAV_FUND]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/suppliersManage/fundDetailNew/supplier${stringify({
        ffrom: erpKeys.ERP_NAV_FUND,
    })}`,
    [erpKeys.ERP_NAV_MYCHANNEL]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/partnerManage/myPartner${stringify({
        ffrom: erpKeys.ERP_NAV_MYCHANNEL,
        source: 'erp' // 业务逻辑: 如果来源是erp的话 我的分销商/我的供应商 有待审核数据筛选出待审核, 无待审核即默认筛选状态
    })}`,
    [erpKeys.ERP_NAV_CHANNEL_GOODS]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/channel/my/myGoods/alreadyReleaseGoods/index${stringify({
        ffrom: erpKeys.ERP_NAV_CHANNEL_GOODS,
        source: 'erp' // 来源是erp,从erp菜单 分销/分销商工具/分销商品点击进入,跳入分销版-我的分销商品页面
    })}`,
    [erpKeys.ERP_NAV_MYSUPPLIER]: `${getTerminaDomain(
        PROJECT_CONFIG.supplierTerminalName,
    )}/suppliersManage/suppliersList/onlineSuppliers${stringify({
        ffrom: erpKeys.ERP_NAV_MYSUPPLIER,
        source: 'erp' // 业务逻辑: 如果来源是erp的话 我的分销商/我的供应商 有待审核数据筛选出待审核, 无待审核即默认筛选状态
    })}`,
    [erpKeys.ERP_INDEX_LINK_ORDER]: {
        [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
            PROJECT_CONFIG.supplierTerminalName,
        )}${SUPPLIER_ORDER_ROUTE}${stringify({
            ffrom: erpKeys.ERP_INDEX_LINK_ORDER,
            orderStatus: 'WaitConfirm',
            orderTypeEnum: 'DIS',
        })}`,
        [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
            PROJECT_CONFIG.channelTerminalName,
        )}${CHANNEL_ORDER_ROUTE}${stringify({
            ffrom: erpKeys.ERP_INDEX_LINK_ORDER,
            orderStatus: 'WaitConfirm',
            orderTypeEnum: 'DIS',
        })}`,
    },
    [erpKeys.ERP_NAV_PROCE_QUANTITY](lastLoginSide) {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.supplierTerminalName,
            )}${SUPPLIER_PROCE_QUANTITY}`,
            [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.channelTerminalName,
            )}${CHANNEL_PROCE_QUANTITY}`,
        }

        if (lastLoginSide) {
            return map[lastLoginSide]
        }

        return map[PROJECT_CONFIG.channelTerminalName]
    },
    [erpKeys.ERP_MENU_IM_DISTRIBUTE](lastLoginSide) {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.supplierTerminalName,
            )}${SUPPLIER_ONLINE_SUPPLIERS}`,
            [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.channelTerminalName,
            )}${CHANNEL_HOME_PAGE}`,
        }

        if (lastLoginSide) {
            return map[lastLoginSide]
        }

        return map[PROJECT_CONFIG.channelTerminalName]
    },
    [erpKeys.ERP_AUTH_PAGE_TO_SHOP_LIST](lastLoginSide) {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.supplierTerminalName,
            )}${SUPPLIER_SHOP_LIST}`,
            [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.channelTerminalName,
            )}${CHANNEL_SHOP_LIST}`,
        }

        if (lastLoginSide) {
            return map[lastLoginSide]
        }

        return map[PROJECT_CONFIG.channelTerminalName]
    },

    // 合伙人招募. 根据用户角色跳转不同系统首页
    [erpKeys.GYL_PARTNERSHIP_INVITE](lastLoginSide) {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)}/dashboard`,
            [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.channelTerminalName,
            )}${CHANNEL_HOME_PAGE}`,
        }

        // 分销和纵横因为是特殊域名，合作人回首页需要回特定首页
        if (isLightChannel) {
            return map[PROJECT_CONFIG.channelTerminalName]
        }
        if (isZongHengApp) {
            return map[PROJECT_CONFIG.supplierTerminalName]
        }

        if (lastLoginSide) {
            return map[lastLoginSide]
        }

        return map[PROJECT_CONFIG.supplierTerminalName]
    },
    /**
     * 合伙人商家管理，审核通过
     */
    [erpKeys.GYL_PARTNERSHIP_WAIT_CONFIRM](lastLoginSide) {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.supplierTerminalName,
            )}${SUPPLY_PRATER_SHIP}${stringify({
                ffrom: erpKeys.GYL_PARTNERSHIP_WAIT_CONFIRM,
                activeKey: 'company',
                openSupplierCommissionModal: 1,
            })}`,
            [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.channelTerminalName,
            )}${CHANNEL_PRATER_SHIP}${stringify({
                ffrom: erpKeys.GYL_PARTNERSHIP_WAIT_CONFIRM,
                activeKey: 'company',
                openSupplierCommissionModal: 1,
            })}`,
        }

        if (lastLoginSide) {
            return map[lastLoginSide]
        }

        return map[PROJECT_CONFIG.supplierTerminalName]
    },
    [erpKeys.ERP_AFTERSALE_AUTO_PUSH](lastLoginSide) {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.supplierTerminalName,
            )}${SUPPLIER_AFTER_SALES_AUTOMATION}${stringify({
                ffrom: erpKeys.ERP_AFTERSALE_AUTO_PUSH,
            })}`,
            [PROJECT_CONFIG.channelTerminalName]: `${getTerminaDomain(
                PROJECT_CONFIG.channelTerminalName,
            )}${CHANNEL_AFTER_SALES_AUTOMATION}${stringify({
                ffrom: erpKeys.ERP_AFTERSALE_AUTO_PUSH,
            })}`,
        }

        if (lastLoginSide) {
            return map[lastLoginSide]
        }

        return map[PROJECT_CONFIG.supplierTerminalName]
    },
}

// 解析url（短链接跳转需要根据lastLoginSide跳转）
const resolveUrl = (url, lastLoginSide) => {
    if (typeof url === 'function') {
        return url(lastLoginSide)
    }

    if (typeof url === 'object' && url) {
        return url[lastLoginSide]
    }

    return url
}

// 回调地址
export const push = ({ url, params = {} }, { decode } = { decode: false }) => {
    const decodeUrl = decode ? decodeURIComponent(url) : url

    const qIndex = decodeUrl.indexOf('?')
    if (qIndex === -1) {
        window.location.href = `${decodeUrl}${Qs.stringify({ ...params }, { addQueryPrefix: true })}`
    } else {
        const path = decodeUrl.slice(0, qIndex)
        const query = decodeUrl.slice(qIndex + 1)
        const queryObj = query ? Qs.parse(query) : {}

        window.location.href = `${path}${Qs.stringify({ ...queryObj, ...params }, { addQueryPrefix: true })}`
    }
}

// 联登
// stayPage 停留在当前页
export const useJumpPage = ({ location, toH5 = false, stayPage = false }) => {
    const [loading, setLoading] = useState(true)

    // 跳转需携带的参数
    const withQuery = useMemo(() => {
        return omit(location.query, ['simple_token', 'access_token', 'redirect', 'ffrom', 't', 'r', 'is_agent'])
    }, [location])

    // eslint-disable-next-line complexity
    const init = useCallback(async () => {
        setLoading(true)

        const {
            query: { simple_token, access_token, redirect, ffrom, t, r, is_agent: _ignore_is_agent, ...restQuery },
        } = location

        const smallUrl = R_MAP[r] // 短链接
        const redirectUrl = redirect || smallUrl
        const source = r ? r : ffrom // 短链接标记同时做为ffrom的值使用，省略多传入一个ffrom
        const loginTerminal = t || TERMINAL_PC

        const directGo = ({ url, params }) => {
            push({ url, params })
        }

        // 跳转到H5
        if (toH5) {
            jstLogPv(null, { force: true })

            const access_token = getToken()

            if (access_token) {
                const resoledUrl = resolveUrl(redirectUrl)

                if (!resoledUrl) {
                    return
                }

                push({ url: resoledUrl, params: { jtoken: access_token } })
            } else {
                directGo({ url: LOGIN_URL })
            }
            return
        }

        // 短token
        if (simple_token) {
            try {
                const { success, data, message } = await erpJointLoginGyl2(
                    { token: simple_token },
                    { fromSource: source },
                )

                if (success || window.PROJECT_CONFIG.mode !== 'prod') {
                    const { access_token } = data || {}
                    // eslint-disable-next-line no-shadow

                    if (!access_token) {
                        captureException('联登失败', {
                            anchor: 'erpJointLoginGyl2',
                            extra: access_token,
                        })
                    } else {
                        setToken({ access_token })
                    }

                    try {
                        const TIMEOUT_TIME = 2000
                        let timer = setTimeout(() => {
                            throw new Error('接口超时')
                        }, TIMEOUT_TIME)
                        await afterLogin({
                            fromSource: ffrom,
                        })
                        await syncApplyCooperationNum()
                        clearTimeout(timer)
                    } catch (error) {
                        console.error('catchError', error)
                    }

                    jstLogPv(null, { force: true })

                    const {
                        data: { lastLoginSide },
                    } = await acquireSimpleUser()

                    const loginGo = ({ url, params }, { decode } = { decode: false }) => {
                        const decodeUrl = decode ? decodeURIComponent(url) : url

                        push({ url: decodeUrl, params })
                    }

                    const resoledUrl = resolveUrl(redirectUrl, lastLoginSide)

                    // erp分销商品价格及库存 按照身份跳转 添加原来redirect参数
                    if (ffrom === erpKeys.ERP_NAV_PROCE_QUANTITY) {
                        const erpPriceUrl = R_MAP[ffrom]
                        const erpPriceResoledUrl = resolveUrl(erpPriceUrl, lastLoginSide)
                        const erpParams = parseUrl(redirectUrl)

                        loginGo({ url: erpPriceResoledUrl, params: erpParams?.query })
                        return
                    }

                    if (ffrom === erpKeys.ERP_MENU_IM_DISTRIBUTE || ffrom === erpKeys.ERP_AUTH_PAGE_TO_SHOP_LIST) {
                        const erpPriceUrl = R_MAP[ffrom]
                        const erpPriceResoledUrl = resolveUrl(erpPriceUrl, lastLoginSide)

                        loginGo({ url: erpPriceResoledUrl, params: restQuery })
                        return
                    }

                    if (resoledUrl) {
                        const params = loginTerminal === TERMINAL_APP ? { jtoken: access_token } : restQuery
                        loginGo({ url: resoledUrl, params }, { decode: true })
                        return
                    }

                    if (lastLoginSide) {
                        const url = getHome(lastLoginSide)

                        loginGo({ url, params: restQuery })
                        return
                    }

                    if (stayPage) {
                        setLoading(false)
                        return
                    }

                    loginGo({ url: ROLE_URL })
                } else {
                    if (message) {
                        $message.error(message)
                    }

                    jstLogPv(null, { force: true })

                    if (stayPage) {
                        setLoading(false)
                        return
                    }

                    setTimeout(() => {
                        directGo({ url: LOGIN_URL })
                    }, 2500)
                }
            } catch (e) {
                console.error('catchError', e)
                Sentry.setExtra('extra', {
                    error: e,
                })
                Sentry.captureException(new Error('ERP联登失败 >> jumpPage'))

                jstLogPv(null, { force: true })

                if (stayPage) {
                    setLoading(false)
                    return
                }

                directGo({ url: LOGIN_URL })
            }

            return
        }

        let resoledUrl = resolveUrl(redirectUrl)

        // 长token
        if (access_token) {
            setToken({ access_token })

            jstLogPv(null, { force: true })

            if (resoledUrl) {
                const url = decodeURIComponent(resoledUrl)

                directGo({ url })
                return
            }

            if (stayPage) {
                setLoading(false)
                return
            }

            directGo({ url: ROLE_URL })
            return
        }

        // 合伙人招募场景下, 需要判断最后登录侧
        if (r === erpKeys.GYL_PARTNERSHIP_INVITE || r === erpKeys.GYL_PARTNERSHIP_WAIT_CONFIRM) {
            const hasToken = getToken()

            if (!hasToken) {
                directGo({
                    url: LOGIN_URL,
                    params: {
                        redirect: encodeURIComponent(window.location.href),
                    },
                })
                return
            }

            const {
                data: { lastLoginSide },
            } = await acquireSimpleUser()

            resoledUrl = resolveUrl(redirectUrl, lastLoginSide)
        }

        // 重定向
        if (resoledUrl) {
            jstLogPv(null, { force: true })

            directGo({ url: resoledUrl, params: restQuery })
            return
        }

        if (stayPage) {
            setLoading(false)
            return
        }

        // 直接去登录
        directGo({ url: LOGIN_URL })

        setLoading(false)
    }, [location, toH5, stayPage])

    useEffect(() => {
        init()
    }, [init])

    const goHome = role => {
        switch (role) {
            case PROJECT_CONFIG.supplierTerminalName:
                push({ url: SUPPLIER_HOME, params: withQuery })
                break
            case PROJECT_CONFIG.channelTerminalName:
                push({ url: CHANNEL_HOME, params: withQuery })
                break
            default:
                push({ url: ROLE_URL })
        }
    }

    return {
        loading,
        goHome,
    }
}

const ERP_ENV = 'erp'

export function isErpEnv() {
    const { f } = window.iFrameParams || {}
    return f === ERP_ENV
}

/** 子应用独立访问环境，TODO 后续其他子应用可以扩展 */
function isLocalEnv() {
    return PROJECT_CONFIG.localTerminalName === 'PRINT' || location.origin.includes('print.scm121.com')
}

/**
 * @param path 增加域名，如果在 erp 内，增加约定参数
 */
export function wrapPath(path) {
    let url = path
    if (url.indexOf('http') !== 0) {
        if (isLocalEnv()) {
            const domain = getLocalTerminalDomain()
            url = `${domain}${path}`
        } else {
            url = (window.__POWERED_BY_GYL_FRAME__ ? window.MASTER_ORIGIN : location.origin) + path
        }
    }
    if (isErpEnv()) {
        url = setParams(url, { f: ERP_ENV, m: 'n' }, false)
    }
    return url
}

/***
 * 如果 isLocalEnv() 为 true，会强制使用窗口打开，兼顾在非框架下运行，找不到路由的情况
 * @param erpTabLink 从 erp tab 打开的路径，默认值 gylOpenLink
 * @param erpTabName erp tab 的标题
 * @param erpTabRefresh 如果已经有打开 erp tab，再次打开是否要刷新，默认值为 false
 * @param gylOpenLink 从供应链打开的路径
 * @param isWindowOpen  是否新窗口方式打开，默认是 true
 */
export function jump({ erpTabLink, erpTabName, erpTabRefresh = false, gylOpenLink, isWindowOpen = true }) {
    if (isWindowOpen || isLocalEnv()) {
        if (isErpEnv()) {
            openErpTab(erpTabName, erpTabLink || wrapPath(gylOpenLink), erpTabRefresh)
        } else {
            window.open(wrapPath(gylOpenLink), '_blank')
        }
    } else {
        history.pushState(null, gylOpenLink, gylOpenLink)
    }
}

/**
 * 打开 ERP tab
 * @param url 如果是 erp 链接可以是相对路径，如果是打开供应链链接，需要通过 wrapPath 处理下
 * @param erpTabRefresh 如果已经有打开 erp tab，再次打开是否要刷新，默认值为 false
 * */
export function openErpTab(name, url, isRefresh = false) {
    window.jst_core.tab.open({
        name, // : '订单管理',
        url, // : 'https://c.jushuitan.com/app/order/order/list.aspx?queryUnshippedTime=12h',
        pic: '',
        isRefresh,
    })
}

/**
 * 支持在erp, epaas打开tab
 * @parambaseEpaasParams:{
 *    serviceKey?: string//服务key,
 *    pageId?: string// 页面 ID
 *    params?: object// 其它参数，跳转时，会拼接到页面的 url 上
 *}

 *@param baseErpParam:{
 *   erpTabLink?: string //从 erp tab 打开的路径，默认值 gylOpenLink
 *   erpTabName: string //erp tab 的标题
 *   erpTabRefresh?: boolean 如果已经有打开 erp tab，再次打开是否要刷新，默认值为 false
 *   url: string //新开浏览器tab地址
 *   m:n 隐藏菜单
 *   isWindowOpen: boolean 是否新窗口打开
 *}
 */
export const serviceKey = 'gyl_print_service'
/**
 * @deprecated 如果需要在多环境中执行跳转请使用新的模块 https://alidocs.dingtalk.com/i/nodes/14lgGw3P8vvXoDxQIAbkRRRX85daZ90D
 */
export const jumpV2 = (baseErpParam, baseEpaasParams) => {
    const erpParam = {
        erpTabRefresh: true,
        isWindowOpen: true,
        ...baseErpParam,
    }

    const epaasParams = {
        serviceKey,
        m: 'n',
        ...(baseEpaasParams || {}),
    }

    window?.hostInstance?.jumpV2(erpParam, epaasParams)
}
/**
 *
 * @deprecated 如果需要在多环境中执行跳转请使用新的模块 https://alidocs.dingtalk.com/i/nodes/14lgGw3P8vvXoDxQIAbkRRRX85daZ90D
 */
export const jumpV3 = opts => {
    // otherOpts 支持属性及默认值 isWindowOpen, tabRefresh = true, serviceKey, pageId = '', params = {}

    const {
        url, // 多数情况下是供应链地址
        tabUrl, // 在epaas、erp中新开tab链接
        tabName,
        ...otherOpts
    } = opts

    const target = {
        url,
        tabName,
        tabUrl,
        ...otherOpts,
    }

    window?.hostInstance?.jumpV3(target)
}

export const generateTerminalUrlInTower = path => {
    const terminalName = window.MASTER_IS_SUPPLIER
        ? window.MASTER_PROJECT_CONFIG.supplierTerminalName
        : window.MASTER_PROJECT_CONFIG.channelTerminalName
    return getLocalTerminalDomain(terminalName) + path
}
